/* eslint-disable simple-import-sort/imports */
/**
 * Components Index
 * @hidden
 */

// Bootstrap imports are global
// eslint-disable-next-line import/no-unassigned-import
import 'bootstrap/js/dist/modal';
// eslint-disable-next-line import/no-unassigned-import
import 'bootstrap/js/dist/collapse';
// eslint-disable-next-line import/no-unassigned-import
import 'bootstrap/js/dist/dropdown';
// eslint-disable-next-line import/no-unassigned-import
import 'bootstrap/js/dist/tab';

import { type App } from '~/app';

import initialiseAccordion from './accordion/accordion';
import initialiseAmenityList from './amenity-list/amenity-list';
import initialiseAmenityListContainer from './amenity-list-container/amenity-list-container';
import initialiseMediaGalleryFeature from './archive/media-gallery/media-gallery';
import initialiseStickySlider from './archive/sticky-slider/sticky-slider';
import initialiseAssetHeroBanner from './banners/asset-hero-banner/asset-hero-banner';
import initialiseMpcTakeoverHero from './banners/mpc-takeover-hero/mpc-takeover-hero';
import initialiseHalcyonHomeHeader from './banners/halcyon-home-header/halcyon-home-header';
import initialiseRichMediaBanner from './banners/rich-media-banner/rich-media-banner';
import initialiseCards from './card/card';
import initialiseCardContainer from './card-container/card-container';
import initialiseCampaignBlock from './campaign-block/campaign-block';
import initialiseSlimCampaignBlock from './slim-campaign-block/slim-campaign-block';
import initialiseAnnouncementTileCarousel from './carousels/announcement-tile-carousel/lazy-carousel';
import initialiseModalCarousel from './carousels/archive/modal-carousel/lazy-carousel';
import initialiseCarousel from './carousels/carousel/lazy-carousel';
import initialiseFeatureStatQuoteCarousel from './carousels/feature-stat-quote-carousel/lazy-carousel';
import initialiseFeaturedPropertysCarousel from './carousels/featured-property-carousel/lazy-carousel';
import initialiseHeroCarousel from './carousels/hero-carousel/lazy-carousel';
import initialiseHorizontalCarousel from './carousels/horizontal-carousel/lazy-carousel';
import initialiseMultiImageCarousel from './carousels/multi-image-carousel/multi-image-carousel'
import initialiseMultiImageInnerCarousel from './carousels/multi-image-inner-carousel/multi-image-inner-carousel';
import initialiseNumberPanelCarousel from './carousels/number-panels-carousel/number-panels-carousel';
import initialisePassiveCarousel from './carousels/passive-carousel/lazy-carousel';
import initialiseVerticalCarousel from './carousels/vertical-carousel/vertical-carousel';
import initialiseClickStream from './clickstream/click-stream';
import initialiseCollapsedFormCta from './collapsed-form-cta/collapsed-form-cta';
import initialiseCommunityTileListing from './community-tiles-listing/community-tiles-listing'
import initialiseVerticalTabBar from './containers/archive/vertical-tab-bar-container/vertical-tab-bar-container';
import initialiseContentContainer from './containers/content-container/content-container';
import initialiseHorizontalTabBar from './containers/horizontal-tab-bar-container/horizontal-tab-bar-container';
import initialiseVerticalTabScroll from './containers/vertical-tab-bar-container/vertical-tab-bar-container';
import initialiseVerticalTabVideo from './containers/vertical-tab-video/vertical-tab-video';
import initialiseEventDetails from './event-details/event-details';
import initialiseRecipePage from './recipe/recipe-body/recipe-body';
import initialiseSearchExperiment from './examples-and-experiments/search-experiment/search-experiment';
import initialiseVueExample from './examples-and-experiments/vue-example/vue-example';
import initialiseFacilitiesFilters from './facilities-filters/facilities-filters';
import initialiseFeatureLinkContainerV2 from './feature-link-container-v2/feature-link-container-v2';
import initialiseFeatureLinksAndImage from './feature-links-and-image/feature-links-and-image';
import initialiseFeaturedEventStatement from './feature-statement/archive/event/event';
import initialiseFeaturedCarousel from './featured-carousel/featured-carousel';
import initialiseFormAndContent from './form-and-content/form-and-content';
import initialiseFormattedTime from './form-and-content/formatted-time/formatted-time';
import initialiseEnquiryContact from './form-and-content/forms/enquiry-contact/enquiry-contact'
import initialiseUnsubscribe from './form-and-content/forms/unsubscribe/unsubscribe';
import initialiseWhistleblower from './form-and-content/forms/whistleblower/whistleblower';
import initialiseEnquiryButton from './global/header/enquiry-button/enquiry-button';
import initialiseGetInTouchButton from './global/header/get-in-touch-button/get-in-touch-button';
import initialiseGlobalNavigation from './global/header/global-navigation/global-navigation';
import initialiseMenuOverlay from './global/header/menu-overlay/menu-overlay';
import initialiseNavigationBar from './global/header/navigation-bar/navigation-bar';
import initialiseRibbonBar from './global/header/ribbon-bar/ribbon-bar';
import initialiseHamburgerMenu from './global/header/hamburger-menu/hamburger-menu';
import initialiseImageAreaFocus from './image-area-focus/image-area-focus';
import initialiseImageRangeSlider from './image-range-slider/image-range-slider';
import initialiseInvestorCentre from './investor-resources/investor-centre/investor-centre';
import initialiseLiveChatMonitoring from './chats/live-chat-monitoring/live-chat-monitoring'
import initialiseSalesforceChat from './chats/salesforce-chat/salesforce-chat'
import initialiseSalesforceChatMIAW from './chats/salesforce-chat-miaw/salesforce-chat-miaw'
import initialiseLlcHomeViz from './llc-home-viz/llc-home-viz';
import initialiseLlcMpcMapContainer from './llc-mpc-map-container/llc-mpc-map-container';
import initialiseMaps from './maps/maps';
import initialiseArticleListing from './media/archive/article-listing/article-listing';
import initialiseMarketplacerProductBlock from './marketplacer/marketplacer-product-block/marketplacer-product-block'
import initialiseMediaGallery from './media-gallery/media-gallery';
import initialiseAnchorLinks from './navigation/anchor-links/anchor-links';
import initialiseWayfindingBar from './navigation/wayfinding-bar/wayfinding-bar';
import initialiseFloatierIsland from './navigation/floating-island-scroll/floating-island-scroll';
import initialiseOffersBlock from './offers/offers-block/offers-block';
import initialiseOffersCard from './offers/offers-card/offers-card';
import initialiseOffersModal from './offers/offers-modal/offers-modal';
import initialiseOffersModalButton from './offers/offers-modal-button/offers-modal-button';
import initialiseOfferTeaser from './card/offer-teaser/offer-teaser';
import initialiseRetailOffersTile from './offers/retail-offers-tile/retail-offers-tile';
import initialiseParallaxScrollBlock from './parallax-scroll-block/parallax-scroll-block';
import initialiseProductSearch from './product/product-search/product-search';
import initialiseProductDetails from './product-details/product-details'
import initialiseProductGallery from './product-gallery/product-gallery'
import initialiseProductTilesandFilters from './property-tiles-and-filters/property-tiles-and-filters'
import initialiseProgressHomeHeader from './_hub/progress-home-header/progress-home-header'
import initialisePromoTileWithIcon from './tile/promo-tile-with-icon/promo-tile-with-icon'
import initialiseRecentlyViewedHomes from './recently-viewed-homes/recently-viewed-homes';
import initialiseResourcesList from './resources-list/resources-list';
import initialiseSearch from './search/search';
import initialiseSearchAssetsBar from './search-assets-bar/search-assets-bar';
import initialiseShrinkingHeader from './shrinking-header/shrinking-header';
import initialiseStageImageWithSteps from './_hub/stage-image-with-steps/stage-image-with-steps'
import initialiseStepByStepFeatureCarousel from './carousels/step-by-step-feature-carousel/step-by-step-feature-carousel'
import initialiseOffersTileAndCarousel from './carousels/offers-tile-and-carousel/offers-tile-and-carousel'
import initialiseTabbedImagePanel from './tabbed-containers/tabbed-image-panel/tabbed-image-panel';
import initialiseTabbedImageWithText from './tabbed-containers/tabbed-image-with-text/tabbed-image-with-text';
import initialiseTakeoverCallout from './takeover-callout/takeover-callout'
import initialiseTakeoverImageWithInlineTabs from './takeover-image-with-inline-tabs/takeover-image-with-inline-tabs';
import initialiseTakeoverCard from './card/takeover-card/takeover-card';
import initialiseTakeoverHighlights from './takeover-highlights/takeover-highlights';
import initialiseCollapseTile from './tile/collapse-tile/collapse-tile';
import initialisePromoTile from './tile/promo-tile/promo-tile';
import initialiseCommunityTiles from './tile/community-tiles/community-tiles'
import initialiseDownloadList from './tile/download-list/download-list';
import initialiseHeroBanner from './tile/hero-slide/hero-slide';
import initialiseMultipleTabTargetSelector from './tile/image-tile-with-inline-tabs/image-tile-with-inline-tabs';
import initialiseMultipleTabTargetSelectorv2 from './tile/image-tile-with-inline-tabs-v2/image-tile-with-inline-tabs-v2';
import initialisePropertyCard from './tile/property-tile-card/property-card';
import initialiseLocationCard from './card/location-tile-card/location-tile-card';
import initialiseLocationTileListing from './location-tile-listing/location-tile-listing';
import initialiseProgressTimeLine from './tile/mpc-progress-timeline/mpc-progress-timeline';
import initialiseProgressBar from './progress-bar/progress-bar';
import initialiseConstructionTracker from './construction-tracker/construction-tracker';
import initialiseArticleMaster from './article-master/article-master';
import initializeLargeImageCard from './card/large-image-card/large-image-card';
import initializeLargeVideoCard from './card/large-video-card/large-video-card';
import initializeInspirationListing from './inspiration-card-listing/inspiration-card-listing';
import initialiseMapWithSupportingContent from './map-with-supporting-content/map-with-supporting-content';
import initialiseStoreCategoryWayfinding from './store-category-wayfinding/store-category-wayfinding';
import initialiseHalfImageBanner from './banners/half-image-banner/half-image-banner';
import initialiseInspireHeader from './inspire-header/inspire-header';
import mountRetailHomeHeader from './retail-home-header/retail-home-header';
import initializeInspirationTilesAndFilter from './inspiration-tiles-and-filters/inspiration-tiles-and-filters';
import initializeGifttile from './tile/gift-tile/gift-tile';
import initializeScrollToCard from './card/scroll-to-card/scroll-to-card';

import initialiseStoreDirectory from './store-directory/store-directory';
import initialiseOfferListing from './offers/offers-listing/offers-listing';

import initialiseRecipeCampaignOneSideScrollTakeover from './recipe-campaign-one-side-scroll-takeover/recipe-campaign-one-side-scroll-takeover'
import initialiseCampaignHeroBanner from './banners/campaign-hero-banner/campaign-hero-banner'

import initialiseEventListingCard from './card/event-listing-card/event-listing-card'
import initialiseRTCEventListing from './rtc-event-listing/rtc-event-listing'


import initialiseFeatureCardsComponent from './feature-cards-component/feature-cards-component';

import intialiseProgressCard from './progress-card/progress-card';

import initialiseSwiper from './swiper/swiper';
import intialiseLocalStorageWrapper from './global/hub-data-wrapper/hub-data-wrapper';
import initialiseWelcomeModal from './hub-welcome-modal/hub-welcome-modal';
import intialiseStepAccordion from './_hub/step-accordion/step-accordion';
import initialiseStepCompletion from './step-completion/step-completion';
import intialiseProductCommutiyExplorer from './product-and-community-explorer/product-and-community-explorer';
import initialiseMicrositeRibbonBar from './global/header/microsite-ribbon-bar/microsite-ribbon-bar';

/**
 * Initialise Components
 * @param app - App framework
 */

export function initialiseComponents(app: App) {
    // Component Registration
    initialiseAmenityList(app);
    initialiseAmenityListContainer(app);
    initialiseArticleListing(app);
    initialiseCards(app);
    initialiseCardContainer(app);
    initialiseCollapseTile(app);
    initialiseFeaturedCarousel(app);
    initialiseDownloadList(app);
    initialiseFeaturedEventStatement(app);
    initialiseFormattedTime(app);
    initialiseHalcyonHomeHeader(app);
    initialiseInvestorCentre(app);
    initialiseImageRangeSlider(app);
    initialiseLlcMpcMapContainer(app);
    initialiseLlcHomeViz(app);
    initialiseMaps(app);
    initialiseEventDetails(app)
    initialiseRecipePage(app)
    initialiseMultipleTabTargetSelector(app);
    initialiseMultipleTabTargetSelectorv2(app);
    initialiseProductSearch(app);
    initialiseResourcesList(app);
    initialiseStoreCategoryWayfinding(app);
    initialiseOffersCard(app);
    initialiseOffersModal(app);
    initialiseOffersModalButton(app);
    initialiseOfferTeaser(app);
    initialisePropertyCard(app);
    initialiseProgressHomeHeader(app);
    initialiseRecentlyViewedHomes(app);
    initialiseWayfindingBar(app);
    initialiseFacilitiesFilters(app);
    initialiseLiveChatMonitoring(app);
    initialiseSearch(app);
    initialiseSearchAssetsBar(app);
    initialiseSearchExperiment(app);
    initialiseStageImageWithSteps(app);
    initialiseTabbedImagePanel(app);
    initialiseTakeoverCallout(app);
    initialiseTakeoverCard(app);
    initialiseUnsubscribe(app);
    initialiseVueExample(app);
    initialiseWhistleblower(app);
    initialiseClickStream(app);
    initialiseRichMediaBanner(app);
    initialiseAnchorLinks(app);
    initialiseEnquiryContact(app);
    initialiseGetInTouchButton(app);
    initialiseCommunityTiles(app)
    initialiseCommunityTileListing(app);
    initialiseProductTilesandFilters(app);
    initialiseProgressTimeLine(app);
    initialiseProgressBar(app);
    initialiseLocationCard(app);
    initialiseLocationTileListing(app);
    initialiseSalesforceChat(app);
    initialiseSalesforceChatMIAW(app);
    initialiseMpcTakeoverHero(app);
    initialiseConstructionTracker(app);
    initialiseArticleMaster(app);
    initializeLargeImageCard(app);
    initializeLargeVideoCard(app);
    initializeInspirationListing(app);
    initialiseMapWithSupportingContent(app);
    initialiseHalfImageBanner(app);
    initialiseInspireHeader(app);
    initialiseOfferListing(app);
    initialiseRetailOffersTile(app);
    initialiseOffersBlock(app);
    initialiseStoreDirectory(app)
    initialiseSlimCampaignBlock(app);
    mountRetailHomeHeader( app );
    initializeGifttile(app);
    initialiseRecipeCampaignOneSideScrollTakeover( app );
    initializeInspirationTilesAndFilter(app);
    initialiseEventListingCard(app);
    initialiseRTCEventListing(app);
    initialiseSwiper(app);
    initializeScrollToCard(app);
    intialiseProductCommutiyExplorer(app);
    initialiseMicrositeRibbonBar(app);

    intialiseLocalStorageWrapper(app);
    intialiseProgressCard(app);
    initialiseHamburgerMenu(app);
    intialiseStepAccordion(app);
    initialiseStepCompletion(app);
    const destroyAnnouncementTileCarousel = initialiseAnnouncementTileCarousel(app);
    const destoryAccordion = initialiseAccordion(app);
    const destoryAssetHeroBanner = initialiseAssetHeroBanner(app);
    const destroyCampaignBlock = initialiseCampaignBlock(app);
    const destroySlimCampaignBlock = initialiseSlimCampaignBlock(app);
    const destroyCarousel = initialiseCarousel(app);
    const destroyCollapsedFormCta = initialiseCollapsedFormCta(app);
    const destroyCollapseTile = initialiseCollapseTile(app);
    const destroyContentContainer = initialiseContentContainer(app);
    const destroyEventDetails = initialiseEventDetails(app)
    const destroyRecipePage = initialiseRecipePage(app)
    const destroyFeaturedCarousel = initialiseFeaturedCarousel(app);
    const destroyFeatureLinksAndImage = initialiseFeatureLinksAndImage(app);
    const destroyFeatureLinkContainerV2 = initialiseFeatureLinkContainerV2(app);
    const destroyFeatureStatQuoteCarousel = initialiseFeatureStatQuoteCarousel(app);
    const destroyFloatingIsland = initialiseFloatierIsland(app);
    const destroyFormAndContent = initialiseFormAndContent(app);
    const destoryHeroBanner = initialiseHeroBanner(app);
    const destroyHeroCarousel = initialiseHeroCarousel(app);
    const destroyHorizontalCarousel = initialiseHorizontalCarousel(app);
    const destroyMediaGallery = initialiseMediaGallery(app);
    const destroyPassiveCarousel = initialisePassiveCarousel(app);
    const destroyPromoTileWithIcon = initialisePromoTileWithIcon(app);
    const destroyFeaturedPropertyCarousel = initialiseFeaturedPropertysCarousel(app);
    const destroyHorizontalTabBar = initialiseHorizontalTabBar(app);
    const destroyImageAreaFocus = initialiseImageAreaFocus(app);
    const destoryNavigationBar = initialiseNavigationBar(app);
    const destroyNumberPanelCarousel = initialiseNumberPanelCarousel(app);
    const destroyMarketplacerProductBlock = initialiseMarketplacerProductBlock(app);
    const destoryMediaGalleryFeature = initialiseMediaGalleryFeature(app);
    const destroyMenuOverlay = initialiseMenuOverlay(app);
    const destroyModalCarousel = initialiseModalCarousel(app);
    const destroyMultiImageInnerCarousel = initialiseMultiImageInnerCarousel(app);
    const destroyMultiImageCarousel = initialiseMultiImageCarousel(app)
    const destroyWayfindingBar = initialiseWayfindingBar(app)
    // const destroyOldCarousel = initialiseOldCarousel(app);
    const destroyMultipleTabTargetSelection = initialiseMultipleTabTargetSelector(app);
    const destroyMultipleTabTargetSelectionV2 = initialiseMultipleTabTargetSelectorv2(app);
    const destroyParallaxScrollBlock = initialiseParallaxScrollBlock(app);
    const destroyProductDetails = initialiseProductDetails(app);
    const destroyProductGallery = initialiseProductGallery(app);
    const destroyPromoTile = initialisePromoTile(app);
    const destroyRibbonBar = initialiseRibbonBar(app);
    const destroyGlobalNavigation = initialiseGlobalNavigation(app);
    const destroyEnquiryButton = initialiseEnquiryButton(app);
    const destroyShrinkingHeader = initialiseShrinkingHeader(app);
    const destroyStepByStepFeatureCarousel = initialiseStepByStepFeatureCarousel(app);
    const destroyOffersTileAndCarousel = initialiseOffersTileAndCarousel(app);
    const destroyStickySlider = initialiseStickySlider(app);
    const destroyVerticalCarousel = initialiseVerticalCarousel(app);
    const destroyVerticalTabScroll = initialiseVerticalTabScroll(app);
    const destroyVerticalTabVideo = initialiseVerticalTabVideo(app);
    const destroyTabbedImageWithText = initialiseTabbedImageWithText(app);
    const destroyTakeoverCard = initialiseTakeoverCard(app);
    const destroyTakeoverImageWithInlineTabs = initialiseTakeoverImageWithInlineTabs(app);
    const destroyTakeoverHighlights = initialiseTakeoverHighlights(app);
    const destroyVerticalTabBar = initialiseVerticalTabBar(app);
    const destroyEnquireContact = initialiseEnquiryContact(app);
    const destroyProgressTimeLine = initialiseProgressTimeLine(app);
    const destroyMpcTakeoverHero = initialiseMpcTakeoverHero(app);
    const destroyCampaignHeroBanner = initialiseCampaignHeroBanner(app);
    const destroyWelcomeModal = initialiseWelcomeModal(app);
    const destroyFeatureCardsComponents = initialiseFeatureCardsComponent(app);
    const destroySwiper = initialiseSwiper(app);

    app.logger.debug('[Stockland FE] Components mounted');

    return function destroyComponents() {
        // Component de-registration
        destoryAccordion();
        destoryAssetHeroBanner();
        destroyCampaignBlock();
        destroySlimCampaignBlock();
        destroyCarousel();
        destroyCollapsedFormCta();
        destroyCollapseTile();
        destroyContentContainer();
        destroyEnquiryButton();
        destroyFeaturedCarousel();
        destroyFeatureLinksAndImage();
        destroyFeatureLinkContainerV2();
        destroyFeatureStatQuoteCarousel();
        destroyFloatingIsland();
        destroyFormAndContent();
        destroyGlobalNavigation();
        destoryHeroBanner();
        destroyHeroCarousel();
        destroyHorizontalCarousel();
        destroyPassiveCarousel();
        destroyAnnouncementTileCarousel();
        destroyFeaturedPropertyCarousel();
        destroyHorizontalTabBar();
        destroyImageAreaFocus();
        destroyMarketplacerProductBlock();
        destoryMediaGalleryFeature();
        destroyMediaGallery();
        destroyMenuOverlay();
        destroyWayfindingBar();
        destroyModalCarousel();
        destroyEventDetails();
        destroyRecipePage();
        destroyMultiImageInnerCarousel()
        destroyMultiImageCarousel();
        destroyMultipleTabTargetSelection();
        destroyMultipleTabTargetSelectionV2();
        destoryNavigationBar();
        destroyNumberPanelCarousel();
        // destroyOldCarousel();
        destroyParallaxScrollBlock();
        destroyProductDetails();
        destroyProductGallery();
        destroyPromoTile();
        destroyPromoTileWithIcon();
        destroyRibbonBar();
        destroyShrinkingHeader();
        destroyStepByStepFeatureCarousel();
        destroyOffersTileAndCarousel();
        destroyStickySlider();
        destroyVerticalCarousel();
        destroyTabbedImageWithText();
        destroyTakeoverCard();
        destroyTakeoverImageWithInlineTabs();
        destroyVerticalTabBar();
        destroyVerticalTabScroll();
        destroyEnquireContact();
        destroyVerticalTabVideo();
        destroyTakeoverHighlights();
        destroyProgressTimeLine();
        destroyMpcTakeoverHero();
        destroyCampaignHeroBanner();
        destroyFeatureCardsComponents();
        destroyCampaignHeroBanner();
        destroyWelcomeModal();

        app.logger.debug('[Stockland FE] Components destroyed');
    };
}
